<template>

                <v-card class="mt-4">
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                        <p style="color: white;">Negociaciones</p>

                    </v-card-title>



                    <v-card-text >


                        <v-card-title>
                            <v-col cols="12">
                                <v-row justify="center">
                                    <h3>{{d3nombre}}</h3>
                                </v-row>
                            </v-col>
                            <!--falta vlidacion de conclusion de daños y lesiones-->
                            <v-col cols="12" v-if="!validaConclusion && ConclusionDanosLes == 0">
                                <v-row>

                                    <v-btn v-if="estatus == 0 && permisoAltaNegociacion"
                                           class="ma-2"
                                           color="green"
                                           title="Agregar"
                                           @click="altaMovimiento()">
                                        <span style='color: white;'>Agregar</span>
                                    </v-btn>
                                    <v-btn v-if="estatus == 0 && permisoAltaNegociacion"
                                           class="ma-2"
                                           color="green"
                                           title="Sin Negociación"
                                           @click="sinNegociacion()">
                                        <span style='color: white;'>Sin Negociación</span>
                                    </v-btn>
                                    <v-btn v-if="estatus == 2 && permisoRespNegociacion"
                                           class="ma-2"
                                           color="green"
                                           title="Responder"
                                           @click="validacionNegociacion()">
                                        <span style='color: white;'>Responder</span>
                                    </v-btn>
                                </v-row>
                            </v-col>
                            <v-col cols="12" >
                                <v-row>
                                    <v-btn v-if="estatus == 1 && permisoRecuperaciones && TipoNeg == 2 && Recuperacion == 0"
                                           class="ma-2"
                                           color="green"
                                           title="Ir a Recuperaciones"
                                           @click="AgregarRecuperacion()">
                                        <span style='color: white;'>Recuperaciones</span>
                                    </v-btn>

                                </v-row>
                            </v-col>
                        </v-card-title>

                        <DataTable :url="urlListado"
                                   :columns="columns"
                                   :params="displayInputs"
                                   :prueba="true"
                                   :rowStyle="style"
                                   :value="displayInputs.d3id"
                                   :order="[]"
                                   @apiDT="apiDT = $event"></DataTable>


                        <v-col md="12">
                            <v-row justify="center">
                                <v-btn dark
                                       class="ma-2"
                                       color="#FF4081"
                                       title="Cancelar"
                                       @click="cancelar()">
                                    <span style='color: white;'>Cancelar</span>
                                </v-btn>
                            </v-row>
                        </v-col>

                    </v-card-text>

                </v-card>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable
        },
        data() {
            return {

                d3nombre: '',
                style:'style',
                urlListado: "ExpJur/ListadoNegociaciones",
                columns: [
                    { name: 'ngtiponegociacion', data: 'ngtiponegociacion', title: "Vamos a" },
                    { name: 'Fecha', data: 'Fecha', title: "Fecha Alta" },
                    { name: 'FechaNegociacion', data: 'FechaNegociacion', title: "Fecha recepción Neg" },
                    { name: 'Monto', data: 'Monto', title: "Monto Negociación" },
                    { name: 'Observaciones', data: 'Observaciones', title: "Observaciones" },
                    { name: 'ngrangomontoaseg', data: 'ngrangomontoaseg', title: "Rango/Monto Aseg" },
                    { name: 'UsAlta', data: 'UsAlta', title: "Usuario Alta"},
                    { name: 'Autorizacion', data: 'Autorizacion', title: "Estatus"},
                    { name: 'UsValida', data: 'UsValida', title: "Usuario Respuesta"},
                    { name: 'FechaRespuesta', data: 'FechaRespuesta', title: "Fecha Respuesta" },
                    { name: 'FechaAsegurado', data: 'FechaAsegurado', title: "Fecha Respuesta Aseg" },
                    { name: 'ObservacionEje', data: 'ObservacionEje', title: "Observaciones" }

                ],
                displayInputs: {
                    d3id: 0
                },
                push: 0,
                validaConclusion: false,
                estatus: null,
                permisoAltaNegociacion: false,
                permisoRespNegociacion: false,
                permisoRecuperaciones: false,
                TipoNeg: null,
                Recuperacion: null,
                ConclusionDanosLes: null



            }
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            async AgregarRecuperacion() {
                if (this.push == 0) {
                    this.push++;
                    //let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
                    //this.$router.push({ name: 'Recuperacion' });

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                    this.$router.push({ path: asistenciaurl + '/Recuperacion' });
                }
            },
            async validacionNegociacion() {
                if (this.push == 0) {
                    this.push++;
                    //this.$router.push({ name: 'ValidacionNegociacion' });

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                    this.$router.push({ path: asistenciaurl + '/ValidacionNegociacion' });

                }
            },
            async altaMovimiento() {
                if (this.push == 0) {
                    this.push++;
                    //this.$router.push({ name: 'AltaMovimientoNegociacion' });

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                    this.$router.push({ path: asistenciaurl + '/AltaMovimientoNegociacion' });
                }
            }, 
            async sinNegociacion() {
                if (this.push == 0) {
                    this.push++;
                    //this.$router.push({ name: 'SinNegociacion' });

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                    this.$router.push({ path: asistenciaurl + '/SinNegociacion' });
                }
            },
            async cancelar() {
                if (this.push == 0) {
                    this.push++;
                    //this.$router.push({ name: 'VolanteExpJur' });

                    let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                    this.$router.push({ path: asistenciaurl + '/Volante' });
                }
                
            }
        },
        async mounted() {
            this.changeReporteMenuOption('VolanteExpJur');
            let validaConc = await MetodosGenerales.getReporteEstatus(this);
            if (validaConc == 2) { // si es 2 es porque esta cerrado
                this.validaConclusion = true;
            }

            let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');

            this.changeReporteMenuOption(clavetercero.urlname);
            this.displayInputs = {
                d3id: clavetercero.d3id,
                nrreporte: clavetercero.nrreporte,
                svindice: clavetercero.svindice
            };

            await Reporte.obtenerEstatusListado(this).then(response => {
                this.d3nombre = response.data[0].d3nombre;
                this.estatus = response.data[0].Estatus;

                this.permisoAltaNegociacion = response.data[0].permisoAltaNegociacion;
                this.permisoRespNegociacion = response.data[0].permisoRespNegociacion;
                this.permisoRecuperaciones = response.data[0].permisoRecuperaciones;

                this.TipoNeg = response.data[0].TipoNeg;
                this.Recuperacion = response.data[0].Recuperacion;
                this.ConclusionDanosLes = response.data[0].ConclusionDanosLes;


            });

        }
    }
</script>